import React from "react";
import { Container } from "semantic-ui-react";
import ChatRoom from "../../containers/ChatRoom";

const PublicChatRoomListPage = () => {
  return (
    <Container fluid className="bg-white1">
      <ChatRoom />
    </Container>
  );
};
export default PublicChatRoomListPage;
